import React from "react";
import styled from "styled-components";
import RouterLink from "gatsby-link";

const Logo = () => (
  <StyledLogo to="/">
    <svg
      width="29"
      height="40"
      viewBox="0 0 635 878"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="currentColor" fillRule="evenodd">
        <path d="M0 478v400c109.79 0 198.917-88.464 199.99-198L200 0H0v478zM435 390.204V680c110.457 0 200-89.543 200-200 0-71.877-37.917-134.899-94.84-170.154C560.92 278.32 573 240.57 573 200 573 89.543 483.457 0 373 0v400c21.642 0 42.48-3.437 62-9.796z" />
        <path d="M281.708 0h100l100 367.148L435.208 680h-153.5z" />
      </g>
    </svg>
  </StyledLogo>
);

const StyledLogo = styled(RouterLink)`
  color: var(--black);
  transition: all 0.5s ease;
  &:hover {
    color: #a1a1a1;
  }
`;

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Header/logo.js